<template>
    <span>{{ date | momentFormat }}</span>
</template>

<script>
    export default {
        name: "DisplayDate",
        props: ['date'],
        filters: {
            momentFormat: function (value) {
                moment.locale(window.config.date_locale);
                return moment(value).format(window.config.date_format + ' HH:mm');
            }
        },
    }
</script>
